import React from 'react'
import ChatWindow from './ChatWindow'
import ChatIndicatorListItemView from './ChatIndicatorListItemView'

export default function ChatIndicatorListItem({ title, onClick, ...rest }) {
    return (
        <ChatWindow {...{
            type: 'private',
            listItem: true,
            listItemTitle: title,
            onListItemClick: onClick,
            ...rest
        }}

        >
            {(props) => <ChatIndicatorListItemView {...props} />}
        </ChatWindow>
    )
}
